// Angular
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DatabaseService } from '../../../../../core/_services/database.service';
import { TaskQueue } from '../../../../../core/_shared/models/task-queue.model';
import { EnumHelper } from '../../../../../core/_shared/utils/enum-helper';
import { BetTaskTypes } from '../../../../../core/_shared/models/BetTaskTypes';

@Component({
	selector: 'app-waiting-task',
	templateUrl: './waiting-task.component.html',
	styleUrls: ['waiting-task.component.scss']
})
export class WaitingTaskComponent implements OnInit,OnDestroy {
	

	unsubscribleCustomerWaitingTasks: () => void;

	// Show dot on top of the icon
	@Input() dot: string;

	// Show pulse on icon
	@Input() pulse: boolean;

	@Input() pulseLight: boolean;

	// Set icon class name
	@Input() icon = 'flaticon2-bell-alarm-symbol';
	//@Input() icon = 'computer';
	@Input() iconType: '' | 'success';

	// Set true to icon as SVG or false as icon class
	@Input() useSVG: boolean;

	// Set bg image path
	@Input() bgImage: string;

	// Set skin color, default to light
	@Input() skin: 'light' | 'dark' | 'lilac'= 'light';

	@Input() type: 'brand' | 'success' = 'success';
	activeProcesses: number = 0;
	public tasks: TaskQueue[] = [];

	/**
	 * Component constructor
	 *
	 * @param sanitizer: DomSanitizer
	 */
	constructor(private sanitizer: DomSanitizer,
		private _database: DatabaseService) {
	}

	backGroundStyle(): string {
		if (!this.bgImage) {
			return 'none';
		}

		return 'url(' + this.bgImage + ')';
	}
	
	ngOnInit(): void {

	

		this.unsubscribleCustomerWaitingTasks = this._database.getCurrentCustomer()
		.getWaitingTasks().getCollection().orderBy("createDate", "desc")
		.onSnapshot(queySnapshot => {
  
	
		  this.activeProcesses = 0;
		  this.tasks = [];
		  queySnapshot.forEach(snapshot => {
			this.activeProcesses++;
 
			let obj = Object.assign(snapshot.data());
			obj.cryptoBetId = btoa(obj.BetId);
			obj.machineId = snapshot.data().ownerTask.machineId;
			obj.taskTypeName =  EnumHelper.GetDescription(BetTaskTypes, snapshot.data().ownerTask.taskType);
			this.tasks.push(obj);
  
		  })
  
		  this.pulse = true;

		  setTimeout(() => {
			  this.pulse = false;
		  }, 5000);

		});
	}

	
	ngOnDestroy(): void {
		this.unsubscribleAll();
	  }
	
	  unsubscribleAll(): void {
	
		if (this.unsubscribleCustomerWaitingTasks != null) {
		  this.unsubscribleCustomerWaitingTasks();
		}

	  }
}
